/**
 * V2 Context Menu — shown when clicking a drop target during move mode.
 *
 * Rendered at fixed position (x, y coordinates).
 *
 * Props:
 *  - show           : boolean
 *  - x, y           : number — screen coordinates
 *  - targetPath     : string — drop target file path
 *  - onMoveHere     : () => void
 *  - onCopyHere     : () => void
 *  - onClose        : () => void
 *  - fromInbox      : boolean — if true, only show "Send here"
 */
export default function NodeV2ContextMenu({
  show,
  x,
  y,
  targetPath,
  onMoveHere,
  onCopyHere,
  onClose,
  fromInbox = false,
}) {
  if (!show) return null;

  return (
    <div
      className="v2-context-menu"
      style={{ left: x, top: y }}
      onClick={(e) => e.stopPropagation()}
    >
      <button className="v2-context-menu-item" onClick={() => { onMoveHere(); onClose(); }}>
        <span className="v2-context-menu-icon">&#x2192;</span>
        Move here
      </button>
    </div>
  );
}
